
import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component({
  components: {}
})
export default class MySetup extends Vue {
  @Prop({ type: Number }) value!: number;
  @Prop({ type: Number, default: 1 }) min!: number;
  @Prop({ type: Number }) max?: number;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  valueChange(value: any) {
    console.log(value);
  }
  @Emit()
  input(value: any) {
    console.log(value);
    const flag = /^(-)?[0-9]*$/;
    if (!flag.test(value)) {
      return this.min ? this.min : null;
    }
    let num = null;
    if (this.max && value > this.max) {
      num = Number(this.max);
    }
    console.log(Number(value), this.min);
    if (Number(value) <= Number(this.min)) {
      num = this.min;
    }
    return num ? Number(num) : Number(value);
  }

  upClick(e: any) {
    let num = this.value + 1;
    if (this.max && this.max < num) {
      num = this.max;
    }
    this.$emit("input", num, "up");
    return num;
  }

  downClick() {
    let num = this.value - 1;
    if (num < this.min) {
      num = this.min;
    }
    this.$emit("input", num, "down");
    return num;
  }
  @Emit()
  change(value: string | number) {
    console.log(value, "value");
    return value;
  }
}
